var uuid = require('uuid').v4;
/**
 * generates random UUID
 * @returns {String}
 */
export var generateUUID = function () { return uuid().replace(/-/g, ''); };
//# sourceMappingURL=generateUUID.js.map